__turbopack_context__.v({
  "badge": "BundleCard-module-scss-module__H2zy4W__badge",
  "body": "BundleCard-module-scss-module__H2zy4W__body",
  "card": "BundleCard-module-scss-module__H2zy4W__card",
  "cta": "BundleCard-module-scss-module__H2zy4W__cta",
  "image": "BundleCard-module-scss-module__H2zy4W__image",
  "imageWrapper": "BundleCard-module-scss-module__H2zy4W__imageWrapper",
  "message": "BundleCard-module-scss-module__H2zy4W__message",
  "originalTotal": "BundleCard-module-scss-module__H2zy4W__originalTotal",
  "priceRow": "BundleCard-module-scss-module__H2zy4W__priceRow",
  "prices": "BundleCard-module-scss-module__H2zy4W__prices",
  "savings": "BundleCard-module-scss-module__H2zy4W__savings",
  "srOnly": "BundleCard-module-scss-module__H2zy4W__srOnly",
  "title": "BundleCard-module-scss-module__H2zy4W__title",
  "total": "BundleCard-module-scss-module__H2zy4W__total",
});
